const RealPeople = () => {
    return (
        <section id="real-people">
            <div className="container-fluid pt-3 pb-3 text-center gg-bg-solid-green-light">
                <div className="row align-items-center justify-content-center">
                    <div className="col-md-10 col-11">
                        <h2 className="mb-4 fw-bold">
                            These are real stories from real people.<br />
                            Each one started where you are right now.
                        </h2>
                        <h5 className="mb-4 fw-light">
                            Tired of blood sugar swings.<br />
                            Craving stability. <br />
                            Ready for something that actually helps.
                        </h5>
                        <p className="mb-4 fw-semibold">
                            Scroll through.<br />
                            See what changed for them.
                        </p>
                        <h5 className="mb-4 fw-light">
                            Then ask yourself:
                        </h5>
                        <h4 ><mark className="gg-mark-yellow">Could this be your turning point too?</mark></h4>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RealPeople;